import React, { useCallback, useState } from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import PdfApi from '../libs/api/PdfApi';
import { saveAs } from 'file-saver';
import Helpers from '../helpers';
import { useLocation, useSearchParams } from 'react-router-dom';
import AuthService from '../services/Auth';


const api = new PdfApi();

export function usePdf() {
  const { pathname } = useLocation();
  const [loadingPdf, setLoadingPdf] = useState(false);
  let [searchParams] = useSearchParams();
  const handleDownloadPdf = async (title) => {
    setLoadingPdf(true);
    try {
      const url = `${process.env.REACT_APP_FRONT_URL
        }${pathname}/print?${searchParams}&token=${AuthService.getToken()}`;
      const response = await api.getPdf(url);
      Helpers.downloadFile(response, `${title}.pdf`);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingPdf(false);
    }
  };

  // const handleDownloadPdfForInterview = useCallback(
  //   async (title) => {
  //     setLoadingPdf(true);
  //     try {
  //       const url = `${process.env.REACT_APP_FRONT_URL
  //         }${pathname}/print?token=${AuthService.getToken()}`;
  //       const response = await api.getPdf(url);
  //       // console.log('response=', response);
  //       Helpers.downloadFile(response, `${title}.pdf`);
  //     } catch (e) {
  //       console.log(e);
  //     } finally {
  //       setLoadingPdf(false);
  //     }
  //   },
  //   [handleDownloadPdf],
  // );

  const handleDownloadPdfForInterview = useCallback(async (title) => {
    setLoadingPdf(true);
    try {
      const url = `${process.env.REACT_APP_FRONT_URL}${pathname}/print?token=${AuthService.getToken()}`;
      const response = await api.getPdf(url);
      if (!response.data) {
        throw new Error('Invalid PDF data');
      }

      const arrayBuffer = await new Response(response.data).arrayBuffer();
      const pdfBytes = new Uint8Array(arrayBuffer);
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();

      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      pages.forEach((page, pageIndex) => {
        const margin = 50;
        const { width, height } = page.getSize();
        const fontSize = 12;
        const pageNumber = pageIndex + 1;
        const textWidth = font.widthOfTextAtSize(pageNumber.toString(), fontSize);
        const textX = width / 2 - textWidth / 2;
        const textY = margin / 2;

        page.drawText(pageNumber.toString(), {
          x: textX,
          y: textY,
          size: fontSize,
          font: font,
          color: rgb(0, 0, 0),
        });


        page.setSize(page.getWidth(), page.getHeight() + 50);
      });

      const modifiedPdfBytes = await pdfDoc.save();
      // Helpers.downloadFile(modifiedPdfBytes, `${title}.pdf`);
      saveAs(new Blob([modifiedPdfBytes], { type: 'application/pdf' }), `${title}.pdf`);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingPdf(false);
    }
  }, [pathname, searchParams]);

  const createCustomEvent = useCallback(() => {
    const event = new CustomEvent('status', { detail: 'ok' });

    setTimeout(() => {
      window.dispatchEvent(event);
    }, 5000);
  }, []);

  return {
    loadingPdf,
    handleDownloadPdf,
    createCustomEvent,
    handleDownloadPdfForInterview,
  };
}
